

export function Person() {
    return(
        <div>
            <div style={{marginBottom: "20px"}}>
                <div>개인정보보호법에 따라 (주)오메가포인트는 개인정보의 항목, 개인정보의 수집 및 이용목적, 개인정보의 보유 및 이용기간, 동의 거부권 및 동의 거부 시 불이익에 관한 사항을 안내 드리오니 자세히 읽은 후 동의하여 주시기 바랍니다.</div>
            </div>
            <div style={{marginBottom: "10px"}}>
                <div>1. 수집하는 개인정보</div>
                <div>- 필수항목: 이름, 연락처, 성별, 학년</div>
            </div>
            <div style={{marginBottom: "10px"}}>
                <div>2. 수집한 개인정보의 이용</div>
                <div>- 회사는 신청을 확인하고 안내하기 위한 목적으로만 개인정보를 이용합니다.</div>
            </div>
            <div style={{marginBottom: "10px"}}>
                <div>3. 개인정보의 보관기간</div>
                <div>- 회사는 원칙적으로 이용자의 개인정보를 서비스 종료 시 지체없이 파기하고 있습니다.</div>
                <div>- 단, 이용자에게 개인정보 보관기간에 대해 별도의 동의를 얻은 경우, 또는 법령에서 일정 기간 정보보관 의무를 부과하는 경우에는 해당 기간 동안 개인정보를 안전하게 보관합니다.</div>
                <div>- 서비스에 대한 원활한 제공을 위해 신청 희망일로부터 1년 보관</div>
            </div>
            <div>
                <div>4. 개인정보 수집 및 이용 동의를 거부할 권리</div>
                <div>- 이용자는 개인정보의 수집 및 이용 동의를 거부할 권리가 있습니다. 신청 시 수집하는 최소한의 개인정보, 즉, 필수 항목에 대한 수집 및 이용 동의를 거부하실 경우, 신청이 어려울 수 있습니다.</div>
            </div>
        </div>
    )
}

export function Transfer() {
    return(
        <div>
            <div style={{marginBottom: "20px"}}>
                <div>1. 회사는 고객의 개인정보를 제2조(수집한 개인정보의 이용)에서 고지한 범위 내에서 사용하며, 동 범위를 초과하여 이용하거나 타인 또는 타기업·기관에 제공하지 않습니다.</div>
            </div>
            <div style={{marginBottom: "10px"}}>
                <div>다만, 다음 사항은 예외로 합니다.</div>
            </div>
            <div style={{marginBottom: "10px"}}>
                <div>① 수사목적으로 관계법률에서 정한 절차와 방법에 따라 수사기관이 개인정보 제공을 요구하는 경우</div>
                <div>② 통계작성, 학술연구나 시장조사 등을 위하여 특정 개인을 식별할 수 없는 형태로 협력사나 연구단체 등에 제공하는 경우</div>
                <div>③ 기타 관계법률의 규정에 따른 요청이 있는 경우</div>
                <div>④ 영업의 영도·합병 등이 발생하는 경우(사전 고지 및 동의 철회권 부여)</div>
            </div>
            <div style={{marginBottom: "10px"}}>
                <div>2. 그 밖에 이용자의 동의를 얻어 제3자에게 개인정보를 제공할 수 있으며, 현재 제공하고 있는 개인정보 현황은 다음과 같습니다.</div>
            </div>
            <div>
                <div>- 제공받는 자: 이용자가 신청한 시매쓰 학원</div>
                <div>- 제공목적: 신청을 확인하고 안내하여 요청사항을 수행</div>
                <div>- 제공항목: 이름, 연락처, 성별, 학년</div>
                <div>- 보유 및 이용기간: 신청 희망일로부터 1년 보관</div>
            </div>
        </div>
    )
}

export function Promotion() {
    return(
        <div>
            <div>시매쓰 학원에서 제공하는 이벤트/혜택 등 다양한 정보를 휴대전화로 받아보실 수 있습니다. 프로모션 정보 수신 동의는 이용자가 신청한 시매쓰 학원을 통해 언제든지 철회 가능합니다.</div>
        </div>
    )
}